import React, { ForwardRefRenderFunction, forwardRef } from 'react';
import { TypeInputTextFields } from '@/core/generated-types';
import { ToolTip } from '../ToolTip';
import classNames from 'classnames';

export interface InputTextProps extends TypeInputTextFields {
  value?: string;
  error?: string | boolean;
  helpText?: string; // Not sure if this prop should be kept or removed.
  className?: string;
  inputClassName?: string;
  pattern?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const InputText: ForwardRefRenderFunction<HTMLInputElement, InputTextProps> = (
  {
    id,
    type,
    label,
    placeholder,
    value = '',
    minLength,
    maxLength,
    pattern,
    helpText,
    error,
    className,
    inputClassName,
    onChange,
    onBlur,
    toolTipContent,
    disabled = false,
  },
  ref,
) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="flex flex-row">
        {label && (
          <label
            htmlFor={id}
            className={`text-sm font-bold ${error && 'text-warning'}`}
          >
            {label}
          </label>
        )}
        {toolTipContent && (
          <ToolTip
            id={`tooltip-${id}`}
            height={17}
            width={17}
            content={toolTipContent}
            classes="ml-1"
            strokeWidth={2.5}
          />
        )}
      </div>

      <input
        className={classNames(
          'my-1 w-full border border-grey-midtone px-4 py-3',
          error && 'border-warning',
          disabled && 'bg-grey-pastel',
          inputClassName,
        )}
        id={id}
        name={id}
        data-testid={id}
        // `phone` is not a valid type, but don't want to change its Contentful types to not break
        // other logic I am not aware of.
        type={type === 'phone' ? 'tel' : type}
        placeholder={placeholder}
        value={value}
        minLength={minLength}
        maxLength={maxLength}
        pattern={pattern}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        aria-label={label}
        ref={ref}
      />
      <div className="text-sm">
        {error && <span className="text-warning">{error}</span>}
        {!error && helpText && (
          <span className=" text-grey-dark">{helpText}</span>
        )}
      </div>
    </div>
  );
};

export default React.memo(forwardRef(InputText));
